import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { multiNoWrap } from '../../../../../../../util/multi-no-wrap'
import { Tooltip, Typography } from '@mui/material'

const useStyles = makeStyles(() => ({
  tooltipOverflowTitle: {
    ...multiNoWrap(1)
  }
}))

export const TooltipOverflowTitle = ({
  title,
  minCharTooltip = 30,
  typographySx = {}
}) => {
  const classes = useStyles()

  const titleTypography = (
    <Typography
      className={classes.tooltipOverflowTitle}
      sx={{ ...typographySx }}
    >
      {title}
    </Typography>
  )

  if (title.length > minCharTooltip) {
    return (
      <Tooltip title={title} placement='top'>
        {titleTypography}
      </Tooltip>
    )
  }

  return titleTypography
}
